import { useLegalDocuments } from '../../hooks/useLegalDocuments'
import { LegalDocumentContent } from '../LegalDocumentContent'
import { LegalPageShell } from '../LegalPageShell'

export function PrivacyPolicyPage() {
  const { data: documents } = useLegalDocuments()
  const privacy = documents?.find(document => document.kind === 'privacy')

  return (
    <LegalPageShell>
      <LegalDocumentContent title="Política de Privacidade" document={privacy} />
    </LegalPageShell>
  )
}
